import { render, staticRenderFns } from "./CommodityVarietyAutocomplete.vue?vue&type=template&id=a94f9c50"
import script from "./CommodityVarietyAutocomplete.vue?vue&type=script&lang=js"
export * from "./CommodityVarietyAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports